import React from "react";
import useMetaTags from "../../hooks/useMetaTags"; // Adjust path based on your project structure

const FutureOfMenstrualCare = () => {
  useMetaTags({
    title: "Why Organic Pads are the Future of Menstrual Care",
    description: "Discover how organic pads are revolutionizing menstrual care with sustainable materials, advanced comfort, and innovative technology.",
    keywords: "future of menstrual care, organic sanitary pads, eco-friendly period products, sustainable menstrual care, innovative period solutions",
    author: "Organic Pads",
    robots: "index, follow",
    canonical: "/future-of-menstrual-care",
    ogTitle: "Why Organic Pads are the Future of Menstrual Care",
    ogDescription: "Explore the future of menstrual care with organic pads—sustainable, comfortable, and designed with innovation in mind.",
    ogImage: "https://plus.unsplash.com/premium_photo-1664375262056-a8503d4d073c?q=80&w=1976",
    ogUrl: "https://organicpads.shop/future-of-menstrual-care",
    ogType: "article",
    twitterCard: "summary_large_image",
    twitterTitle: "The Future of Menstrual Care: Why Organic Pads Lead the Way",
    twitterDescription: "Organic pads are setting new standards in menstrual care with sustainable materials and advanced comfort features.",
    twitterImage: "https://plus.unsplash.com/premium_photo-1664375262056-a8503d4d073c?q=80&w=1976",
    twitterSite: "@OrganicPads",
    twitterCreator: "@OrganicPads",
  });

  const schemaMarkup = {
    "@context": "https://schema.org",
    "@type": "Article",
    "mainEntityOfPage": {
      "@type": "WebPage",
      "@id": "/future-of-menstrual-care"
    },
    "headline": "Why Organic Pads are the Future of Menstrual Care",
    "description": "Discover how organic pads are revolutionizing menstrual care with sustainable materials, advanced comfort, and innovative technology.",
    "image": "https://plus.unsplash.com/premium_photo-1664375262056-a8503d4d073c?q=80&w=1976",
    "author": {
      "@type": "Organization",
      "name": "Organic Pads",
      "url": "/"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Organic Pads",
      "logo": {
        "@type": "ImageObject",
        "url": "/logo.png"
      }
    },
    "datePublished": "2025-02-24",
    "dateModified": "2025-02-24",
    "keywords": [
      "future of menstrual care",
      "organic sanitary pads",
      "eco-friendly period products",
      "sustainable menstrual care",
      "innovative period solutions"
    ]
  }
  

  return (
    <>
    <div className="max-w-3xl mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold text-gray-900 mb-4">
        Why Organic Pads are the Future of Menstrual Care
      </h1>
      <img
        src="https://plus.unsplash.com/premium_photo-1664375262056-a8503d4d073c?q=80&w=1976&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
        alt="Future of Care"
        className="w-full rounded-lg mb-4"
      />
      <p className="text-gray-700 mb-4">
        The future of menstrual care is heading towards more sustainable,
        health-conscious solutions. Organic pads lead this revolution by
        combining eco-friendly materials with advanced comfort technology,
        setting new standards for period care.
      </p>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">
        Future-Forward Benefits
      </h2>
      <ul className="list-disc list-inside text-gray-700 mb-4">
        <li>Innovative sustainable materials</li>
        <li>Advanced absorption technology</li>
        <li>Smart design features</li>
        <li>Eco-conscious manufacturing</li>
        <li>Improved comfort systems</li>
      </ul>

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">
        How to Stay Ahead?
      </h2>
      <p className="text-gray-700 mb-4">
        Choose <strong>innovative organic</strong> products that incorporate the
        latest advancements in sustainable technology. The future of period care
        is here.
      </p>
      <img
        src="https://plus.unsplash.com/premium_photo-1702598576513-fe7425ebf6bd?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTN8fG9yZ2FuaWMlMjBzYW5pdGFyeSUyMHBhZHN8ZW58MHx8MHx8fDA%3D.jpg"
        alt="Innovation"
        className="w-full rounded-lg mb-4"
      />

      <h2 className="text-2xl font-semibold text-gray-800 mb-3">Final Thoughts</h2>
      <p className="text-gray-700 mb-4">
        Be part of the menstrual care revolution. <strong>Embrace the future with organic pads!</strong>
      </p>
    </div>
    {/* Schema Markup */}
    <script type="application/ld+json">
        {JSON.stringify(schemaMarkup)}
      </script>
    </>
  );
};

export default FutureOfMenstrualCare;